import BucketCacheService from "../../infrastructure/Services/BucketCacheService";

/** Proveedores que escribía `addGalleryTrackToPlaylist` en `metadata.provider`. */
const GALLERY_PROVIDERS = new Set(["ccmixter", "incompetech", "opengameart"]);

/**
 * Pistas que dejó la galería "Música libre" (retirada en #737): `source` era la
 * URL remota http(s) del proveedor y se reproducían a través de un proxy local
 * que ya no existe. Se reconocen por su procedencia persistida (el proveedor
 * del catálogo o `metadata.sourceUrl === source`, ambos escritos solo por la
 * galería), no por el protocolo: una fila http(s) sin esa procedencia no la
 * escribió la galería y la migración no borra datos ajenos. Esas remotas
 * genéricas siguen teniendo camino de reproducción (`PlaylistTrack` las baja
 * por fetch y las cachea como blob), así que borrarlas sería perder pistas del
 * usuario; lo único que se fue con #737 es el proxy que envolvía ese fetch.
 */
export const isLegacyRemoteGalleryTrack = (track: {
  source?: unknown;
  metadata?: { provider?: unknown; sourceUrl?: unknown } | null;
}): boolean => {
  if (typeof track.source !== "string" || !/^https?:\/\//i.test(track.source)) {
    return false;
  }
  const meta = track.metadata ?? undefined;
  const provider = typeof meta?.provider === "string" ? meta.provider : "";
  return GALLERY_PROVIDERS.has(provider) || meta?.sourceUrl === track.source;
};

/**
 * Borra del caché de audio (`BucketCacheService`, sin TTL) los bytes que la
 * galería bajó para esas pistas; se llama fuera de la transacción de la
 * migración, de forma best-effort.
 */
export const forgetLegacyGalleryAudio = async (
  sources: string[],
): Promise<void> => {
  for (const source of sources) {
    try {
      await BucketCacheService.delete(source);
    } catch {
      /* el caché puede no existir (tests, primer arranque) */
    }
  }
};
